/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './login/login.component.ngfactory';
import * as i4 from './core/home/home.component.ngfactory';
import * as i5 from './app.component.ngfactory';
import * as i6 from '@angular/common';
import * as i7 from '@angular/platform-browser';
import * as i8 from '@angular/animations/browser';
import * as i9 from '@angular/platform-browser/animations';
import * as i10 from '@angular/animations';
import * as i11 from '@angular/http';
import * as i12 from '@angular/router';
import * as i13 from '@angular/forms';
import * as i14 from 'ng2-dragula/components/dragula.provider';
import * as i15 from 'ngx-bootstrap/pagination/pagination.config';
import * as i16 from '../../app/services/connect-extreme.service';
import * as i17 from '../../app/services/util.service';
import * as i18 from '../../app/services/data.service';
import * as i19 from '../../app/services/plan.service';
import * as i20 from '../../app/plan/service/plan-main.service';
import * as i21 from '../../app/services/sales.service';
import * as i22 from '../../app/services/maker.service';
import * as i23 from '../../app/app.config';
import * as i24 from '../../app/services/new-car.service';
import * as i25 from '../../app/services/fukusha.service';
import * as i26 from '../../app/services/globalvariable.service';
import * as i27 from '../../app/services/news.service';
import * as i28 from '../../app/plan/planone/services/planone.service';
import * as i29 from '../../app/plan/plantwo/services/plantwo.service';
import * as i30 from '../../app/plan/planthree/services/planthree.service';
import * as i31 from '../../app/plan/planone/services/planloanmain.service';
import * as i32 from '../../app/services/login.service';
import * as i33 from '../../app/services/auth-guard.service';
import * as i34 from '../../app/services/osusume.service';
import * as i35 from '../../app/services/auth-guard-menu.service';
import * as i36 from '../../app/services/usedcar-detail.service';
import * as i37 from '@ngrx/store';
import * as i38 from '@ngrx/store-devtools';
import * as i39 from '../../app/login/login.component';
import * as i40 from '../../app/core/home/home.component';
import * as i41 from '../../app/app.routing';
import * as i42 from 'angular2-fontawesome/src/index';
import * as i43 from 'primeng/components/common/shared';
import * as i44 from 'primeng/components/dialog/dialog';
import * as i45 from 'primeng/components/button/button';
import * as i46 from 'primeng/components/calendar/calendar';
import * as i47 from 'ng2-currency-mask/src/currency-mask.module';
import * as i48 from 'ng2-dragula/components/dragular.module';
import * as i49 from 'primeng/components/dropdown/dropdown';
import * as i50 from 'primeng/components/paginator/paginator';
import * as i51 from 'primeng/components/datatable/datatable';
import * as i52 from 'ngx-bootstrap/pagination/pagination.module';
import * as i53 from '../../app/shared/shared.module';
import * as i54 from '../../app/core/core.module';
import * as i55 from '../../app/login/login.module';
import * as i56 from '../../app/plan/payment-way/loan/reducers/paymentloan';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.LoginComponentNgFactory,i4.HomeComponentNgFactory,i5.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i6.NgLocalization,i6.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i7.DomSanitizer,i7.ɵe,[i6.DOCUMENT]),i0.ɵmpd(6144,
          i0.Sanitizer,(null as any),[i7.DomSanitizer]),i0.ɵmpd(4608,i7.HAMMER_GESTURE_CONFIG,
          i7.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,i7.EVENT_MANAGER_PLUGINS,
          (p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
            return [new i7.ɵDomEventsPlugin(p0_0),new i7.ɵKeyEventsPlugin(p1_0),new i7.ɵHammerGesturesPlugin(p2_0,
                p2_1)];
          },[i6.DOCUMENT,i6.DOCUMENT,i6.DOCUMENT,i7.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
          i7.EventManager,i7.EventManager,[i7.EVENT_MANAGER_PLUGINS,i0.NgZone]),i0.ɵmpd(135680,
          i7.ɵDomSharedStylesHost,i7.ɵDomSharedStylesHost,[i6.DOCUMENT]),i0.ɵmpd(4608,
          i7.ɵDomRendererFactory2,i7.ɵDomRendererFactory2,[i7.EventManager,i7.ɵDomSharedStylesHost]),
          i0.ɵmpd(5120,i8.AnimationDriver,i9.ɵc,([] as any[])),i0.ɵmpd(5120,i8.ɵAnimationStyleNormalizer,
              i9.ɵd,([] as any[])),i0.ɵmpd(4608,i8.ɵAnimationEngine,i9.ɵb,[i8.AnimationDriver,
              i8.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i9.ɵe,
              [i7.ɵDomRendererFactory2,i8.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i7.ɵSharedStylesHost,(null as any),[i7.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i7.Meta,i7.Meta,
              [i6.DOCUMENT]),i0.ɵmpd(4608,i7.Title,i7.Title,[i6.DOCUMENT]),i0.ɵmpd(4608,
              i10.AnimationBuilder,i9.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
                  i7.DOCUMENT]),i0.ɵmpd(4608,i11.BrowserXhr,i11.BrowserXhr,([] as any[])),
          i0.ɵmpd(4608,i11.ResponseOptions,i11.BaseResponseOptions,([] as any[])),
          i0.ɵmpd(5120,i11.XSRFStrategy,i11.ɵb,([] as any[])),i0.ɵmpd(4608,i11.XHRBackend,
              i11.XHRBackend,[i11.BrowserXhr,i11.ResponseOptions,i11.XSRFStrategy]),
          i0.ɵmpd(4608,i11.RequestOptions,i11.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i11.Http,i11.ɵc,[i11.XHRBackend,i11.RequestOptions]),i0.ɵmpd(5120,i12.ActivatedRoute,
              i12.ɵf,[i12.Router]),i0.ɵmpd(4608,i12.PreloadAllModules,i12.PreloadAllModules,
              ([] as any[])),i0.ɵmpd(6144,i12.PreloadingStrategy,(null as any),[i12.PreloadAllModules]),
          i0.ɵmpd(135680,i12.RouterPreloader,i12.RouterPreloader,[i12.Router,i0.NgModuleFactoryLoader,
              i0.Compiler,i0.Injector,i12.PreloadingStrategy]),i0.ɵmpd(4608,i12.NoPreloading,
              i12.NoPreloading,([] as any[])),i0.ɵmpd(5120,i12.ROUTER_INITIALIZER,
              i12.ɵi,[i12.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i12.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i13.ɵi,i13.ɵi,([] as any[])),i0.ɵmpd(4608,
              i13.FormBuilder,i13.FormBuilder,([] as any[])),i0.ɵmpd(4608,i14.DragulaService,
              i14.DragulaService,([] as any[])),i0.ɵmpd(4608,i15.PaginationConfig,
              i15.PaginationConfig,([] as any[])),i0.ɵmpd(4608,i16.ConnectExtremeService,
              i16.ConnectExtremeService,[i11.Http]),i0.ɵmpd(4608,i17.UtilService,i17.UtilService,
              ([] as any[])),i0.ɵmpd(4608,i18.DataService,i18.DataService,[i17.UtilService]),
          i0.ɵmpd(4608,i19.PlanService,i19.PlanService,[i11.Http,i12.Router,i18.DataService,
              i17.UtilService]),i0.ɵmpd(4608,i20.PlanMainService,i20.PlanMainService,
              [i11.Http,i12.Router,i0.Injector,i19.PlanService,i18.DataService,i17.UtilService]),
          i0.ɵmpd(4608,i21.SalesService,i21.SalesService,[i11.Http,i12.Router,i18.DataService]),
          i0.ɵmpd(4608,i22.MakerService,i22.MakerService,[i11.Http,i23.APP_CONFIG,
              i12.Router,i18.DataService]),i0.ɵmpd(4608,i24.NewCarService,i24.NewCarService,
              [i11.Http,i23.APP_CONFIG,i12.Router,i18.DataService]),i0.ɵmpd(4608,i25.FukushaService,
              i25.FukushaService,[i11.Http,i12.Router,i18.DataService]),i0.ɵmpd(4608,
              i26.GlobalvariableService,i26.GlobalvariableService,[i11.Http,i12.Router,
                  i18.DataService]),i0.ɵmpd(4608,i27.NewsService,i27.NewsService,[i11.Http,
              i12.Router,i18.DataService]),i0.ɵmpd(4608,i28.PlanoneService,i28.PlanoneService,
              ([] as any[])),i0.ɵmpd(4608,i29.PlantwoService,i29.PlantwoService,([] as any[])),
          i0.ɵmpd(4608,i30.PlanthreeService,i30.PlanthreeService,([] as any[])),i0.ɵmpd(4608,
              i31.PlanLoanMain,i31.PlanLoanMain,[i20.PlanMainService]),i0.ɵmpd(4608,
              i32.LoginService,i32.LoginService,[i11.Http,i12.Router,i18.DataService,
                  i20.PlanMainService]),i0.ɵmpd(4608,i33.AuthGuard,i33.AuthGuard,[i12.Router,
              i32.LoginService,i20.PlanMainService,i18.DataService]),i0.ɵmpd(4608,
              i34.OsusumeService,i34.OsusumeService,[i11.Http,i12.Router,i18.DataService]),
          i0.ɵmpd(4608,i35.AuthGuardMenu,i35.AuthGuardMenu,[i12.Router,i20.PlanMainService,
              i18.DataService]),i0.ɵmpd(4608,i36.UsedcarDetailService,i36.UsedcarDetailService,
              [i11.Http,i18.DataService,i12.Router]),i0.ɵmpd(135680,i37.State,i37.State,
              [i37.ActionsSubject,i37.ReducerObservable,i37.ScannedActionsSubject,
                  i37.INITIAL_STATE]),i0.ɵmpd(5120,i38.ɵj,i38.ɵc,([] as any[])),i0.ɵmpd(4608,
              i38.ɵk,i38.ɵk,[i38.ɵj]),i0.ɵmpd(5120,i38.ɵh,i38.ɵf,[i38.ɵi]),i0.ɵmpd(4608,
              i38.StoreDevtools,i38.StoreDevtools,[i38.ɵg,i37.ActionsSubject,i37.ReducerObservable,
                  i38.ɵk,i37.ScannedActionsSubject,i37.INITIAL_STATE,i38.ɵh]),i0.ɵmpd(5120,
              i37.StateObservable,i38.ɵd,[i38.StoreDevtools]),i0.ɵmpd(4608,i37.Store,
              i37.Store,[i37.StateObservable,i37.ActionsSubject,i37.ReducerManager]),
          i0.ɵmpd(5120,i38.ɵa,i38.ɵb,[i38.ɵj,i38.ɵh]),i0.ɵmpd(512,i6.CommonModule,
              i6.CommonModule,([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i7.ɵa,([] as any[])),
          i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i12.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i12.ɵg,i12.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i7.ɵc(p0_0,p0_1),i12.ɵh(p1_0)];
              },[[2,i7.NgProbeToken],[2,i0.NgProbeToken],i12.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i7.BrowserModule,i7.BrowserModule,[[3,i7.BrowserModule]]),i0.ɵmpd(512,
              i9.BrowserAnimationsModule,i9.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i11.HttpModule,i11.HttpModule,([] as any[])),i0.ɵmpd(1024,i12.ɵa,
              i12.ɵd,[[3,i12.Router]]),i0.ɵmpd(512,i12.UrlSerializer,i12.DefaultUrlSerializer,
              ([] as any[])),i0.ɵmpd(512,i12.ChildrenOutletContexts,i12.ChildrenOutletContexts,
              ([] as any[])),i0.ɵmpd(256,i12.ROUTER_CONFIGURATION,{preloadingStrategy:i12.PreloadAllModules},
              ([] as any[])),i0.ɵmpd(1024,i6.LocationStrategy,i12.ɵc,[i6.PlatformLocation,
              [2,i6.APP_BASE_HREF],i12.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i6.Location,
              i6.Location,[i6.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i12.ROUTES,
              () => {
                return [[{path:'',redirectTo:'/home',pathMatch:'full'},{path:'login',
                    component:i39.LoginComponent},{path:'home',component:i40.HomeComponent,
                    canActivate:[i33.AuthGuard],canActivateChild:[i33.AuthGuard]},
                    {path:'newcar',loadChildren:'./newcar/newcar.module#NewcarModule'},
                    {path:'usedcar',loadChildren:'./usedcar/usedcar.module#UsedcarModule'},
                    {path:'sales',loadChildren:'./sales/sales.module#SalesModule'},
                    {path:'planmain',loadChildren:'./plan/plan.module#PlanModule',
                        canActivate:[i33.AuthGuard,i35.AuthGuardMenu],canActivateChild:[i33.AuthGuard]},
                    {path:'business-manage',loadChildren:'./business-manage/business-manage.module#BusinessManageModule'},
                    {path:'fukusha',loadChildren:'./fukusha/fukusha.module#FukushaModule'},
                    {path:'osusume',loadChildren:'./osusume/osusume.module#OsusumeModule',
                        canActivate:[i33.AuthGuard],canActivateChild:[i33.AuthGuard]}]];
              },([] as any[])),i0.ɵmpd(1024,i12.Router,i12.ɵe,[i0.ApplicationRef,i12.UrlSerializer,
              i12.ChildrenOutletContexts,i6.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i12.ROUTES,i12.ROUTER_CONFIGURATION,[2,i12.UrlHandlingStrategy],
              [2,i12.RouteReuseStrategy]]),i0.ɵmpd(512,i12.RouterModule,i12.RouterModule,
              [[2,i12.ɵa],[2,i12.Router]]),i0.ɵmpd(512,i41.AppRoutingModule,i41.AppRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i42.Angular2FontawesomeModule,i42.Angular2FontawesomeModule,
              ([] as any[])),i0.ɵmpd(512,i43.SharedModule,i43.SharedModule,([] as any[])),
          i0.ɵmpd(512,i44.DialogModule,i44.DialogModule,([] as any[])),i0.ɵmpd(512,
              i13.ɵba,i13.ɵba,([] as any[])),i0.ɵmpd(512,i13.FormsModule,i13.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i45.ButtonModule,i45.ButtonModule,([] as any[])),
          i0.ɵmpd(512,i46.CalendarModule,i46.CalendarModule,([] as any[])),i0.ɵmpd(512,
              i13.ReactiveFormsModule,i13.ReactiveFormsModule,([] as any[])),i0.ɵmpd(512,
              i47.CurrencyMaskModule,i47.CurrencyMaskModule,([] as any[])),i0.ɵmpd(512,
              i48.DragulaModule,i48.DragulaModule,([] as any[])),i0.ɵmpd(512,i49.DropdownModule,
              i49.DropdownModule,([] as any[])),i0.ɵmpd(512,i50.PaginatorModule,i50.PaginatorModule,
              ([] as any[])),i0.ɵmpd(512,i51.DataTableModule,i51.DataTableModule,([] as any[])),
          i0.ɵmpd(512,i52.PaginationModule,i52.PaginationModule,([] as any[])),i0.ɵmpd(512,
              i53.ShareModule,i53.ShareModule,([] as any[])),i0.ɵmpd(512,i54.CoreModule,
              i54.CoreModule,([] as any[])),i0.ɵmpd(512,i55.LoginModule,i55.LoginModule,
              ([] as any[])),i0.ɵmpd(131584,i37.ActionsSubject,i37.ActionsSubject,
              ([] as any[])),i0.ɵmpd(131584,i38.ɵg,i38.ɵg,([] as any[])),i0.ɵmpd(2048,
              i37.ReducerManagerDispatcher,(null as any),[i38.ɵg]),i0.ɵmpd(256,i37._INITIAL_STATE,
              (undefined as any),([] as any[])),i0.ɵmpd(1024,i37.INITIAL_STATE,i37._initialStateFactory,
              [i37._INITIAL_STATE]),i0.ɵmpd(256,i37._INITIAL_REDUCERS,{paymentloan:i56.reducer},
              ([] as any[])),i0.ɵmpd(2048,i37._STORE_REDUCERS,(null as any),[i37._INITIAL_REDUCERS]),
          i0.ɵmpd(1024,i37.INITIAL_REDUCERS,i37._createStoreReducers,[i0.Injector,
              i37._INITIAL_REDUCERS,i37._STORE_REDUCERS]),i0.ɵmpd(256,i37._REDUCER_FACTORY,
              i37.combineReducers,([] as any[])),i0.ɵmpd(256,i37.META_REDUCERS,([] as any[]),
              ([] as any[])),i0.ɵmpd(1024,i37.REDUCER_FACTORY,i37.createReducerFactory,
              [i37._REDUCER_FACTORY,i37.META_REDUCERS]),i0.ɵmpd(131584,i37.ReducerManager,
              i37.ReducerManager,[i37.ReducerManagerDispatcher,i37.INITIAL_STATE,i37.INITIAL_REDUCERS,
                  i37.REDUCER_FACTORY]),i0.ɵmpd(2048,i37.ReducerObservable,(null as any),
              [i37.ReducerManager]),i0.ɵmpd(131584,i37.ScannedActionsSubject,i37.ScannedActionsSubject,
              ([] as any[])),i0.ɵmpd(512,i37.StoreRootModule,i37.StoreRootModule,[i37.ActionsSubject,
              i37.ReducerObservable,i37.ScannedActionsSubject]),i0.ɵmpd(512,i38.StoreDevtoolsModule,
              i38.StoreDevtoolsModule,([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,
              ([] as any[])),i0.ɵmpd(256,i23.APP_CONFIG,i23.AppConfig,([] as any[])),
          i0.ɵmpd(256,i38.ɵi,{},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvaGFtYWRhL0RvY3VtZW50cy9naXRfdmVyaWZ5L2t1cnVtYWppdGVuX2FvdC9rdXJ1bWFqaXRlbi9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvaGFtYWRhL0RvY3VtZW50cy9naXRfdmVyaWZ5L2t1cnVtYWppdGVuX2FvdC9rdXJ1bWFqaXRlbi9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts